import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { AdminFormGroup, Module } from "../../../models";

export class ModuleForm extends AdminFormGroup {
  id = this.get('id') as FormControl;
  name = this.get('name') as FormControl;
  description = this.get('description') as FormControl;
  hasApi = this.get('hasApi') as FormControl;
  apiUrl = this.get('apiUrl') as FormControl;
  apiKey = this.get('apiUrl') as FormControl;
  sortOrder = this.get('sortOrder') as FormControl;
  isActive = this.get('isActive') as FormControl;
  applicationId = this.get('applicationId') as FormControl;

  constructor(readonly module: Module, readonly fb: FormBuilder = new FormBuilder()) {
    super(fb.group({
      id: [module?.id, Validators.required],
      name: [module?.name, Validators.required],
      description: [module?.description],
      hasApi: [module?.hasApi],
      apiUrl: [module?.apiUrl],
      apiKey: [module?.apiKey],
      sortOrder: [module?.sortOrder],
      isActive: [module?.isActive],
      applicationId: [module?.applicationId]
    }).controls);
  }

  getItem(): Module {

    var module = {
      id: this.id.value,
      name: this.name.value,
      description: this.description.value,
      hasApi:this.hasApi.value,
      apiUrl: this.apiUrl.value,
      apiKey: this.apiKey.value,
      sortOrder: this.sortOrder.value,
      isActive: this.isActive.value,
      applicationId: this.applicationId.value
    };

    return module;
  }

}
